import { UUID } from "uuidjs"

export default function ordereduuid() {
  let uuid = UUID.genV1()
  let final = uuid.hexFields.timeHiAndVersion + 
  uuid.hexFields.timeMid + 
  uuid.hexFields.timeLow + 
  uuid.hexFields.clockSeqHiAndReserved + 
  uuid.hexFields.clockSeqLow + 
  uuid.hexFields.node
  return final.toUpperCase().slice(0, 32)
}